import { Typography } from "@mui/material";
import { useLogoutViewModel } from "./Logout.vm";

export const Logout = () => {
	useLogoutViewModel();
	return <Typography> Please wait... </Typography>;
};
